<form [formGroup]="savingProductTermsForm">
  <div class="layout-row-wrap gap-2px responsive-column">
    <mat-form-field class="flex-48">
      <mat-label>{{ 'labels.inputs.Nominal Annual Interest' | translate }}</mat-label>
      <input
        type="number"
        matInput
        matTooltip="{{ 'tooltips.The default interest rate set' | translate }}"
        formControlName="nominalAnnualInterestRate"
        required
      />
      <mat-error>
        {{ 'labels.inputs.Nominal Annual Interest' | translate }} {{ 'labels.commons.is' | translate }}
        <strong>{{ 'labels.commons.required' | translate }}</strong>
      </mat-error>
    </mat-form-field>

    <span class="flex-48 hide-lt-md"></span>

    <mat-form-field class="flex-48">
      <mat-label>{{ 'labels.inputs.Interest Compounding Period' | translate }}</mat-label>
      <mat-select
        formControlName="interestCompoundingPeriodType"
        matTooltip="{{ 'tooltips.The period at which interest rate' | translate }}"
        required
      >
        @for (interestCompoundingPeriodType of interestCompoundingPeriodTypeData; track interestCompoundingPeriodType) {
          <mat-option [value]="interestCompoundingPeriodType.id">
            {{ interestCompoundingPeriodType.value | translateKey: 'catalogs' }}
          </mat-option>
        }
      </mat-select>
      <mat-error>
        {{ 'labels.inputs.Interest Compounding Period' | translate }} {{ 'labels.commons.is' | translate }}
        <strong>{{ 'labels.commons.required' | translate }}</strong>
      </mat-error>
    </mat-form-field>

    <mat-form-field class="flex-48">
      <mat-label>{{ 'labels.inputs.Interest Posting Period' | translate }}</mat-label>
      <mat-select
        formControlName="interestPostingPeriodType"
        matTooltip="{{ 'tooltips.Interest rate is posted or credited to a saving account' | translate }}"
        required
      >
        @for (interestPostingPeriodType of interestPostingPeriodTypeData; track interestPostingPeriodType) {
          <mat-option [value]="interestPostingPeriodType.id">
            {{ interestPostingPeriodType.value | translateKey: 'catalogs' }}
          </mat-option>
        }
      </mat-select>
      <mat-error>
        {{ 'labels.inputs.Interest Posting Period' | translate }} {{ 'labels.commons.is' | translate }}
        <strong>{{ 'labels.commons.required' | translate }}</strong>
      </mat-error>
    </mat-form-field>

    <mat-form-field class="flex-48">
      <mat-label>{{ 'labels.inputs.Interest Calculated using' | translate }}</mat-label>
      <mat-select
        formControlName="interestCalculationType"
        matTooltip="{{ 'tooltips.The method used to calculate interest' | translate }}"
        required
      >
        @for (interestCalculationType of interestCalculationTypeData; track interestCalculationType) {
          <mat-option [value]="interestCalculationType.id">
            {{ interestCalculationType.value | translateKey: 'catalogs' }}
          </mat-option>
        }
      </mat-select>
      <mat-error>
        {{ 'labels.inputs.Interest Calculated using' | translate }} {{ 'labels.commons.is' | translate }}
        <strong>{{ 'labels.commons.required' | translate }}</strong>
      </mat-error>
    </mat-form-field>

    <mat-form-field class="flex-48">
      <mat-label>{{ 'labels.inputs.Days in Year' | translate }}</mat-label>
      <mat-select
        formControlName="interestCalculationDaysInYearType"
        matTooltip="{{ 'tooltips.To calculate interest' | translate }}"
        required
      >
        @for (
          interestCalculationDaysInYearType of interestCalculationDaysInYearTypeData;
          track interestCalculationDaysInYearType
        ) {
          <mat-option [value]="interestCalculationDaysInYearType.id">
            {{ interestCalculationDaysInYearType.value | translateKey: 'catalogs' }}
          </mat-option>
        }
      </mat-select>
      <mat-error>
        {{ 'labels.inputs.Days in Year' | translate }} {{ 'labels.commons.is' | translate }}
        <strong>{{ 'labels.commons.required' | translate }}</strong>
      </mat-error>
    </mat-form-field>
  </div>

  <div class="layout-row align-center gap-2percent margin-t responsive-column">
    <button mat-raised-button matStepperPrevious>
      <fa-icon icon="arrow-left" class="m-r-10"></fa-icon>
      {{ 'labels.buttons.Previous' | translate }}
    </button>
    <button mat-raised-button matStepperNext>
      {{ 'labels.buttons.Next' | translate }}
      <fa-icon icon="arrow-right" class="m-l-10"></fa-icon>
    </button>
  </div>
</form>
